import React from 'react';
import Slider from "react-slick";

export default function HomeChoose() {

  const settings = {
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 5000,  
    cssEase: "ease",

    customPaging: function () {
      return <button className="custom-dot"></button>;
    },


    responsive: [

      {
        breakpoint: 1029,
        settings: { slidesToShow: 3 },
      },

      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 },
      },
    ],

  };

  return (
    <>
      <section className="home-choose">
        <div className="choose-slider-sec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-7">
                <div className="choose-text center-heading">
                  <h2 className="heading">The Supershine Advantage!</h2>
                </div>
              </div>
            </div>
            <div className="choose-slider-main">
              <Slider {...settings} className="choose-slider">
                <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/choose-icon1.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Proven Expertise</div>
                    <p>
                      Backed by 35+ years of experience in industrial laundry project engineering, delivering reliable results across industries.
                    </p>
                  </div>
                </div>
                <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/choose-icon2.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Custom Solutions</div>
                    <p>
                      Each project is crafted around your space, workflow, and capacity needs, ensuring maximum efficiency, value, and long-term ROI.
                    </p>
                  </div>
                </div>
                <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/trusted-img-inner.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Trusted Service</div>
                    <p>
                      Our dedicated service team provides timely maintenance and responsive support, ensuring minimal downtime and consistent performance.
                    </p>
                  </div>
                </div>
                {/* <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/choose-icon4.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Engineering Support</div>
                    <p>
                      Each project is crafted around your space, workflow, and capacity needs, ensuring maximum efficiency, value, and long-term ROI.
                    </p>
                  </div>
                </div> */}
                <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/peer-img.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Genuine Spare Parts</div>
                    <p> Authentic spare parts backed by Supershine expertise for faster replacements and reduced downtime.</p>
                  </div>
                </div>
                <div className="choose-col">
                  <div className="why-card ">
                    <div className="iocns">
                      <img src="/assets/images/global-img.webp" className="icon" alt="Proven Expertise" />
                    </div>
                    <div className="heading">Global Presence</div>
                    <p> A strong international footprint supported by regional offices, enabling local execution, faster support, and consistent standards across markets. </p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <div className="home-featured-bg">
          <img src="/assets/images/choose-main-img.webp" alt="Featured" className="img-responsive" />
        </div>
      </section>
    </>
  )
}
